

import { request } from "../network/request";
const db = "dn0";
// SVN权限地址管理列表
export function getSvnManageList(params) {
    return request({
        url: "pmp/svn/svnManageList",
        method: "get",
        params: {
            db,
            ...params,
        },
    });
}
// 根据项目获取要处理计划节点信息
export function getXmPlanModelList(params) {
    return request({
        url: "pmp/svn/getXmPlanModelList",
        method: "get",
        params: {
            db,
            ...params,
        },
    });
}
// SVN编号重复判断
export function checkSvnNumber(params) {
    return request({
        url: "pmp/svn/checkSvnNumber",
        method: "get",
        params: {
            db,
            ...params,
        },
    });
}
// SVN权限地址管理保存
export function saveSvnManage(params) {
    return request({
        url: "pmp/svn/saveSvnManage",
        method: "get",
        params: {
            db,
            ...params,
        },
    });
}
//SVN管理是否是质量管理角色
export function isZgRole() {
    return request({
        url: "pmp/svn/isZgRole",
        method: "get",
        params: {
            db,
        },
    });
}
//SVN管理一键处理/处理
export function svnManageSolve(params) {
    return request({
        url: "pmp/svn/svnManageSolve",
        method: "get",
        params: {
            db,
            ...params
        },
    });
}
// 获取项目SVN编号列表
export function getXmSvnBhList(bmbh) {
    return request({
        url: "pmp/svn/getXmSvnBhList",
        method: "get",
        params: {
            db,
            bmbh
        },
    });
}
// SVN管理一键处理项目数
export function svnManageXmsSolve() {
    return request({
        url: "pmp/svn/svnManageXmsSolve",
        method: "get",
        params: {
            db,
        },
    });
}
//导出
export function exportSvnManage(params) {
    return request({
        url: "pmp/svn/exportSvnManage",
        method: "get",
        params,
    });
}
